"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Select = _interopRequireDefault(require("../../../Select"));
var _TicketType = _interopRequireWildcard(require("../TicketType"));
var _tagsSelect = require("../../../../icons-react/tags-select");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SelectDefaultProps = _Select["default"].defaultProps,
  SelectPropTypes = _Select["default"].propTypes,
  StyledOption = _Select["default"].StyledOption,
  StyledStatusIcon = _Select["default"].StyledStatusIcon;
var TicketPropTypes = _TicketType["default"].propTypes;
var TicketTypeSelector = /*#__PURE__*/function (_React$PureComponent) {
  function TicketTypeSelector(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketTypeSelector);
    _this = _callSuper(this, TicketTypeSelector, [props]);
    _this.state = {
      isOpen: false
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleToggle = _this.handleToggle.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketTypeSelector, _React$PureComponent);
  return (0, _createClass2["default"])(TicketTypeSelector, [{
    key: "handleChange",
    value: function handleChange(_ref) {
      var detail = _ref.detail;
      var value = detail.value;
      var onChange = this.props.onChange;
      onChange(value);
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(isOpen) {
      this.setState({
        isOpen: isOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isOpen = this.state.isOpen;
      var _this$props = this.props,
        value = _this$props.value,
        options = _this$props.options;
      return /*#__PURE__*/_react["default"].createElement(StyledTicketTypeSelector, (0, _extends2["default"])({}, this.props, {
        value: value,
        options: options,
        headRenderer: TicketTypeSelector.headRenderer(isOpen),
        onChange: this.handleChange,
        onToggle: this.handleToggle,
        optionRenderer: TicketTypeSelector.optionRenderer
      }));
    }
  }], [{
    key: "headRenderer",
    value: function headRenderer(isOpen) {
      return function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          subtype = _ref2.subtype,
          type = _ref2.type;
        return /*#__PURE__*/_react["default"].createElement(StyledHeader, null, /*#__PURE__*/_react["default"].createElement(StyledTicketType, {
          subtype: subtype,
          type: type
        }), /*#__PURE__*/_react["default"].createElement(StyledOpenIcon, {
          open: isOpen
        }));
      };
    }
  }, {
    key: "optionRenderer",
    value: function optionRenderer() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        subtype = _ref3.subtype,
        type = _ref3.type;
      return /*#__PURE__*/_react["default"].createElement(_TicketType["default"], {
        subtype: subtype,
        type: type
      });
    }
  }]);
}(_react["default"].PureComponent);
TicketTypeSelector.propTypes = _objectSpread(_objectSpread({}, SelectPropTypes), {}, {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread(_objectSpread({}, TicketPropTypes), {}, {
    title: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  })).isRequired).isRequired
});
TicketTypeSelector.defaultProps = _objectSpread({}, SelectDefaultProps);
var StyledTicketTypeSelector = (0, _styledComponents["default"])(_Select["default"]).withConfig({
  displayName: "TicketTypeSelector__StyledTicketTypeSelector",
  componentId: "sc-12lp6zj-0"
})(["background-color:transparent;height:23px;width:100%;position:relative;> button{padding:0;}", "{display:none;}", "{align-items:center;color:inherit !important;display:flex;height:45px;}"], StyledStatusIcon, StyledOption);
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "TicketTypeSelector__StyledHeader",
  componentId: "sc-12lp6zj-1"
})(["align-items:center;display:flex;height:23px;width:100%;position:relative;"]);
var StyledTicketType = (0, _styledComponents["default"])(_TicketType["default"]).withConfig({
  displayName: "TicketTypeSelector__StyledTicketType",
  componentId: "sc-12lp6zj-2"
})(["padding-right:30px;"]);
var StyledOpenIcon = (0, _styledComponents["default"])(_tagsSelect.Open).withConfig({
  displayName: "TicketTypeSelector__StyledOpenIcon",
  componentId: "sc-12lp6zj-3"
})(["height:auto;position:absolute;right:10px;width:10px;", ""], function (_ref4) {
  var open = _ref4.open;
  return open && "\n    transform: rotate(180deg);\n  ";
});
TicketTypeSelector.TYPES = _TicketType.TYPES;
TicketTypeSelector.SUBTYPES = _TicketType.SUBTYPES;
var _default = exports["default"] = TicketTypeSelector;